import type { ReactNode } from 'react';

// ── StatCard ──────────────────────────────────────────────────────────────────
// Compact KPI tile shared across Finance pages (Accounts Payable / Receivable,
// Bank, Profit) so the header row looks and behaves identically everywhere —
// one component instead of four near-identical copies. Deliberately tight
// (small icon badge, small value) rather than the large avatar-circle KPI
// cards used elsewhere in the app.

interface StatCardProps {
  icon?:       ReactNode;
  label:       string;
  value:       string;
  sub?:        string;
  valueColor?: string;
  iconBg?:     string;
  iconColor?:  string;
}

export function StatCard({ icon, label, value, sub, valueColor, iconBg, iconColor }: StatCardProps) {
  return (
    <div className="stat-tile">
      <div className="stat-tile-head">
        {icon && (
          <span className="stat-tile-icon" style={{ background: iconBg, color: iconColor }}>
            {icon}
          </span>
        )}
        <span className="stat-tile-label">{label}</span>
      </div>
      <div className="stat-tile-value" style={valueColor ? { color: valueColor } : undefined}>{value}</div>
      {sub && <div className="stat-tile-sub">{sub}</div>}
    </div>
  );
}
